import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/providerSearch.svg?url_encode")